/**
 * @param returningUser {Object}
 * @return {void}
 */
module.exports = function fillInReturningUserEmail(returningUser) {
    if ("Email" in returningUser) {
        document.querySelectorAll('[data-component="returning-user-email-placeholder"]').forEach(emailPlaceholder => {
            emailPlaceholder.innerText = returningUser.Email;
        });
    }
}